import React, {useEffect, useState} from 'react';
import HomeIcon from "../../shared/icons/HomeIcon";
import style from "./style.module.scss"
import cn from "classnames";
import {Order} from "../../../services";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import EditIconNew from '../../shared/icons/EditIconNew';
import DeleteNewIcon from '../../shared/icons/DeleteNewIcon';
import ConfirmModal from '../../shared/ConfirmModal/ConfirmModal';
import OrdersLocationEditModal from './OrdersLocationEditModal';
import {requestErrorDisplay} from "../../../utils";

const OrdersLocationDropdownItem = ({item, clickHandle, isSender = false, onDeleted, onUpdated}) => {
  const {t} = useTranslation()
  const [city, setCity] = useState(null)
  const [country, setCountry] = useState(null)
  const [isConfirmOpen, setConfirmOpen] = useState(false)
  const [isEditOpen, setEditOpen] = useState(false)
  const [isDeleting, setDeleting] = useState(false)

  useEffect(() => {
    Order.getCountryById(item.countryId)
      .then(res => res.data)
      .then((response) => {
          setCountry(response);
      })
      .catch(error => {
        console.log(error);
        toast.error(error)
      });
    Order.getCityById(item.cityId)
      .then(res => res.data)
      .then((response) => {
        setCity(response);
      }).catch(error => {
        console.log(error);
        toast.error(error)
      });
  }, [])

  const stopPropagation = (event, action) => {
    event.stopPropagation();
    action();
  }

  const deleteHandle = () => {
    setDeleting(true)
    Order.deleteUserAddress(item.id)
      .then(() => {
        toast.info(t("ordersLocationAddModal.toast.deleteSuccess"))
        setConfirmOpen(false)
        onDeleted?.(item)
      })
      .catch(error => {
        requestErrorDisplay(error)
      })
      .finally(() => {
        setDeleting(false)
      })
  }

  return (
    <>
      <div className={style.dropdown_card} onClick={() => clickHandle(item)}>
        <HomeIcon />
        <div className={style.dropdown_card_content}>
          <h4>{country?.name}, {city?.name}, {item.fullAddress}</h4>
          <p>{item.phoneNumber}</p>
        </div>
        <EditIconNew
          className={cn("ms-auto")}
          onClick={(event) => stopPropagation(event, () => setEditOpen(true))}
        />
        <DeleteNewIcon
          style={{ marginLeft: "4px" }}
          onClick={(event) => stopPropagation(event, () => setConfirmOpen(true))}
        />
      </div>

      <ConfirmModal
        isOpen={isConfirmOpen}
        title={t("ordersLocationAddModal.deleteConfirm.title")}
        message={t("ordersLocationAddModal.deleteConfirm.message")}
        confirmText={t("ordersLocationAddModal.deleteConfirm.confirm")}
        onConfirm={deleteHandle}
        onCancel={() => setConfirmOpen(false)}
        isLoading={isDeleting}
      />

      {isEditOpen && (
        <OrdersLocationEditModal
          key={item?.id}
          item={item}
          isSender={isSender}
          onClose={() => setEditOpen(false)}
          updateContent={(updated) => {
            setEditOpen(false)
            onUpdated?.(updated)
          }}
        />
      )}
    </>
  );
};

export default OrdersLocationDropdownItem;
